import api, { ResponseCallback } from '../services/api.service'
import routeUtil from '../utils/route.util'
import { ContactSiteData } from './contactSite.api'
import { ItemData } from './item.api'
import { SiteData } from './site.api'

export interface PurchaseOrderData {
  id: number
  siteId: number
  vendorSiteId: number
  createdBy: number
  updatedBy: number
  deletedBy?: number
  code: string
  line: string
  deliveryAt: string
  deletedAt?: string
  createdAt: string
  updatedAt: string
  isDelete: boolean
  vendorSite?: ContactSiteData
  items?: ItemData
  site?: SiteData
}

interface PurchaseOrderCreateRequestItem {
  id: number
  quantity: number
}

export interface PurchaseOrderCreateRequest {
  purchaseOrder?: string
  line?: string
  vendorSite?: number
  items?: PurchaseOrderCreateRequestItem[]
  deliveryAt?: string
}

export interface PurchaseOrderImportRequestPurchaseOrder {
  purchaseOrder: string
  line: string
  vendor: string
  vendorSite: string
  item: string
  quantity: string
  deliveryAt: string
}

export interface PurchaseOrderImportRequest {
  purchaseOrders?: PurchaseOrderImportRequestPurchaseOrder[]
}

const routes = {
  create: '/purchaseOrders',
  exist: '/purchaseOrders/{code}/exist',
  import: '/purchaseOrders/import',
  searchByCode: '/purchaseOrders/search/code',
  listItems: '/purchaseOrders/{id}/items'
}

export default {
  create (
    payload: PurchaseOrderCreateRequest,
    callback: ResponseCallback<PurchaseOrderData>
  ) {
    api.post(routes.create, payload, callback)
  },

  exist (
    code: string,
    callback: ResponseCallback<PurchaseOrderData | null>
  ) {
    const url = routeUtil.replaceParams(routes.exist, { code })
    api.get(url, {}, callback)
  },

  import (
    payload: PurchaseOrderImportRequest,
    callback: ResponseCallback<PurchaseOrderData[]>
  ) {
    api.post(routes.import, payload, callback)
  },

  searchByCode (code: string, callback: ResponseCallback<PurchaseOrderData[]>) {
    const params = { code }
    api.get(routes.searchByCode, params, callback)
  },

  listItems (id: number, callback: ResponseCallback<ItemData[]>) {
    const url = routeUtil.replaceParams(routes.listItems, { id })
    api.get(url, {}, callback)
  }
}
